import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../Style/Services.css';
import { Link } from 'react-router-dom';

gsap.registerPlugin(ScrollTrigger);


const Services = () => {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const cardsRef = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Title animation - replays on each scroll
      gsap.fromTo(titleRef.current,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        }
      );

      // Cards stagger animation - replays on each scroll
      gsap.fromTo(cardsRef.current,
        { y: 40, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          stagger: 0.1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: titleRef.current,
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  const addToRefs = (el) => {
    if (el && !cardsRef.current.includes(el)) {
      cardsRef.current.push(el);
    }
  };
  
  return (
    <section className="services" ref={sectionRef}>
      <h2 ref={titleRef}>Printed Circuit Board Assembly Manufacturing
Services:<br></br> Prototype to Production</h2>

      <div className="services-container">
        <div className="card" ref={addToRefs}>
            <img src="/CAPABILITIES-1.png" alt="PCB Assembly" style={{width:"80px", height:"80px"}}/>
          <h1>PCB ASSEMBLY</h1>
          <p>Ensure flawless PCB assembly with our precision manufacturing, designed for reliability and performance in every build. From prototypes to large-scale production, we deliver unmatched quality, on time, every time.</p>
  <Link to="/service/PCB" className="gradient-button">Learn More</Link>

        </div>
        <div className="card" ref={addToRefs}>
              <img src="/CAPABILITIES-1.png" alt="PCB Assembly" style={{width:"80px", height:"80px"}}/>
          <h1>Prototyping & (NPI)</h1>
          <p>Accelerate your product development with our expert PCB assembly services, tailored for prototypes and New Product Introduction (NPI). We ensure rapid, high-quality builds to help you innovate faster and launch with confidenc</p>
    
     <Link to="/service/Prototyping" className="gradient-button">Learn More</Link>

   

        </div>
        <div className="card" ref={addToRefs}>
              <img src="/CAPABILITIES-1.png" alt="PCB Assembly" style={{width:"80px", height:"80px"}}/>
          <h1>Supply Chain & Logistics</h1>
          <p>Don't want to waste your time sourcing and ordering individual parts? Let Automotive Devices handle that for you.</p>
  <Link to="/service/Supply" className="gradient-button">Learn More</Link>

        </div>
        <div className="card" ref={addToRefs}>
              <img src="/CAPABILITIES-1.png" alt="PCB Assembly" style={{width:"80px", height:"80px"}}/>
          <h1>Quality Control & Inspection</h1>
          <p>Quality is paramount at Automotive Devices, where our rigorous inspection processes, including AOI and X-ray, ensure every board meets our high standards.</p>
 <Link to="/quality" className="gradient-button">Learn More</Link>

        </div>
        <div className="card" ref={addToRefs}>
              <img src="/CAPABILITIES-1.png" alt="PCB Assembly" style={{width:"80px", height:"80px"}}/>
          <h1>System/Box Build</h1>
          <p>Our system and box build services offer a hassle-free experience, taking care of everything from assembly to packaging. With our expertise, we ensure your product is built with care and ready to perform, giving you peace of mind every step of the way.</p>
  <Link to="/service/System" className="gradient-button">Learn More</Link>

        </div>
        <div className="card" ref={addToRefs}>
              <img src="/CAPABILITIES-1.png" alt="PCB Assembly" style={{width:"80px", height:"80px"}}/>
          <h1>PCB Design & Engineering</h1>
          <p>Our experienced engineers design and optimize PCB layouts for DFM performance and manufacturability.</p>
 <Link to="/service/PCB" className="gradient-button">Learn More</Link>

        </div>
        <div className="card" ref={addToRefs}>
              <img src="/CAPABILITIES-1.png" alt="PCB Assembly" style={{width:"80px", height:"80px"}}/>
          <h1>PCB Fabrication</h1>
          <p>Automotive Devices can fulfill all your PCB needs, including fully customized designs with variable densities, layer counts, materials, processes, and finishes.</p>
  <Link to="/service/Fabrication" className="gradient-button">Learn More</Link>

        </div>
        <div className="card" ref={addToRefs}>
              <img src="/CAPABILITIES-1.png" alt="PCB Assembly" style={{width:"80px", height:"80px"}}/>
          <h1>Testing & Reliability</h1>
          <p>Our extensive testing capabilities, from functional testing to electrical testing, guarantee that your products are reliable and ready for market challenges.</p>
  <Link to="/product-focus" className="gradient-button">Learn More</Link>

        </div>
      </div>
    </section>
  );
};

export default Services;
